import { AloftPrice, schAloftPrice } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { RootState, SubjectPropertyDataState } from '../../types.ts';
import { selectPropertyDataById } from './propertyDataSelectors/propertyDataSelectors.ts';

export const selectOpinionOfSiteValue = createSelector(
  [(state: RootState) => selectPropertyDataById(state, 'subject')],
  (subjectPropertyDataEntity) =>
    (subjectPropertyDataEntity as SubjectPropertyDataState)?.subjectData.editableData
      .opinionOfSiteValue ?? AloftPrice.zero.toJSON(),
);

export const selectOpinionOfSiteValuePrice = createSelector(
  selectOpinionOfSiteValue,
  (opinionOfSiteValue) => {
    const parsedValue = schAloftPrice.parse(opinionOfSiteValue);
    if (parsedValue.unitAmount === 0) return undefined;

    return parsedValue;
  },
);

export const selectOpinionOfSiteValueDisplay = createSelector(
  selectOpinionOfSiteValuePrice,
  (opinionOfSiteValue) =>
    opinionOfSiteValue ? schAloftPrice.parse(opinionOfSiteValue).toString(true) : '',
);

export const selectSiteValueCommentary = createSelector(
  [(state: RootState) => selectPropertyDataById(state, 'subject')],
  (subjectPropertyDataEntity) =>
    (subjectPropertyDataEntity as SubjectPropertyDataState)?.subjectData.editableData
      .siteValueCommentary ?? '',
);
